export default "__VITE_ASSET__bWjn7e0l__"